import crud from './_crud'
import { callApi } from 'utils/api'
import { showErrorMessage, showSuccessMessage } from 'utils/messages'
const FETCH_INTERNAL_ORDERS = 'FETCH_INTERNAL_ORDERS';
const LOAD_INTERNAL_ORDERS = 'LOAD_INTERNAL_ORDERS';

const actions = crud(
	'internal_order',
	'Orden Interna',
	'Ordenes Internas'
)

const createOrder = (item, files) => {
	return async (dispatch, getState) => {
		const state = getState()

		console.log(item)
		console.log(files)

		const res = await callApi(`/internal_order/create_order`, {
			method: 'PUT',
			json: false,
			headers: {
				Authorization: state.app.user.token,
			},
			body: {
				item: JSON.stringify(item),
				files: files,
			},

			successMessage: 'Se creo la orden correctamente',
		})

		const storedItem = res.body.internalOrderResponse
		dispatch({
			type: 'ADD_INTERNAL_ORDER',
			response: storedItem,
		})
		return storedItem
	}
}

const updateAsset = (item, files) => {
	return async (dispatch, getState) => {
		const state = getState()

		const res = await callApi(`/internal_order/modify_order/${item.id}`, {
			method: 'PUT',
			json: false,
			headers: {
				Authorization: state.app.user.token,
			},
			body: {
				item: JSON.stringify(item),
				files: files,
			},

			// files: files,

			successMessage: `Se edito la orden correctamente.`,
		})
		const updatedItem = await dispatch(getByIDInternalOrder(item.id))
		dispatch({
			type: 'UPDATE_INTERNAL_ORDER',
			response: updatedItem,
		})
		return updatedItem
	}
}
  
const getHistory = () => {
	return async (dispatch, getState) => {
		const state = getState();

		const res = await callApi(`/get_orders_history`, {
			method: 'GET',
			headers: {
				Authorization: state.app.user.token,
			}
		})

		return res.body
	}
}

const getByIDInternalOrder = (id, options = {}) => {
	return async (dispatch, getState) => {
	  const state = getState();
	  dispatch({
		type: `FETCH_INTERNAL_ORDER`,
	  });
	  
	  try {
		const res = await callApi(`/internal_order/load_internal_order/${id}`, {
		  method: 'GET',
		  headers: {
			Authorization: state.app.user.token
		  },
		  params: options.params
		});

		// ? Me dijeron que lo quitara, que solo el primer usuario pudiera verlos
		// if (parseInt(res.body.user_id) !== parseInt(state.app.user.id) && !state.app.user.allow_see_all_intern_orders) {
		// 	showErrorMessage({
		// 		error: `${id} NOT FOUND INTERNAL_ORDER`
		// 	})
		//   throw new Error('Unauthorized access'); // Lanza un error si el usuario no está autorizado
		// }

		dispatch({
		  type: `LOAD_INTERNAL_ORDER`,
		  response: res.body,
		  payload: id
		});
  
		return res.body;
	  } catch (error) {
		// Manejar el error aquí, puedes despachar otra acción con el error o realizar otras acciones necesarias
		// También puedes lanzar nuevamente el error para que el componente que llama a esta acción pueda manejarlo
		throw error;
	  }
	}
  }
  
const loadInternalOrders = (options = {}) => {
    return async (dispatch, getState) => {
      const state = getState();
      //  Check if the entities have been loaded before
      if (Object.keys(state[`internal_orders`].entities).length <= 2 || options.force === true) {
        dispatch({
          type: `FETCH_INTERNAL_ORDERS`,
        })

		if(!options.params){
			options.params = {}
		}

		if(!state.app.user.allow_see_all_intern_orders){
			options.params.user_id = state.app.user.id;
		}

        const res = await callApi(`/internal_order/load_internal_order_filters`, {
          method: 'GET',
          headers: {
            Authorization: state.app.user.token
          },
          params: options.params
        })

        dispatch({
          type: `LOAD_INTERNAL_ORDERS`,
          response: res.body,
        })


        return res.body;
      }

    }
  }


  const loadInternalOrderHistory = (id) => {
	return async (dispatch, getState) => {
		const state = getState()

		const res = await callApi(`/internal_order_history/load_internal_order_history/${id}`, {
			method: 'GET',
			headers: {
				Authorization: state.app.user.token,
			},
		})

		dispatch({ type: `LOAD_INTERNAL_ORDER_HISTORY`, payload: res.body })
		return res.body
	}
}

const getUnreadInternalOrderNotificationsCount = () => {
	return async (dispatch, getState) => {
		const state = getState()

		const res = await callApi(`/internal_order/get_unread_internal_order_notifications_count`, {
			method: 'GET',
			headers: {
				Authorization: state.app.user.token,
			},
		})

		return res.body
	}
}

export default { 
	...actions,
	createOrder,
	updateAsset,
	getHistory,
	loadInternalOrders,
	getByIDInternalOrder,
	loadInternalOrderHistory,
	getUnreadInternalOrderNotificationsCount,

}
